import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Image, Select, type SelectProps, Text } from "@mantine/core";
import { checkCountryCode } from "src/utils/helpers";

import { useCountries } from "../../hooks/locale";

interface ItemComponentProps extends React.ComponentPropsWithoutRef<"div"> {
    value: string;
    label: string;
}

const ItemComponent = forwardRef<HTMLDivElement, ItemComponentProps>(({ value, label, ...others }: ItemComponentProps, ref) => {
    return (
        <div ref={ref} {...others}>
            <Flex align="center">
                <Image
                    src={`/images/flags/${value}.svg`}
                    width="auto"
                    height={18}
                    radius="sm"
                    mr="xs"
                />
                <Text>{label}</Text>
            </Flex>
        </div>
    );
});

export interface SelectCountryProps extends Partial<SelectProps> {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?(countryCode: string);
}

export const SelectCountry = ({ label, placeholder, value, onChange, ...rest }: SelectCountryProps) => {
    const { t } = useTranslation(["common"]);

    const { countries } = useCountries();

    return (
        <Select
            {...rest}
            label={label || label === null ? label : t("country")}
            placeholder={placeholder || t("country_select")}
            nothingFound={t("nothing_found")}
            itemComponent={ItemComponent}
            data={countries.map((country) => ({
                value: country?.code,
                label: checkCountryCode(country?.code) ? t(`country_${country?.code}`) : country?.code,
            }))}
            value={value}
            onChange={onChange}
        />
    );
};
